"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.GroupFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V13.25C1.5 13.9404 2.05964 14.5 2.75 14.5H13.25C13.9404 14.5 14.5 13.9404 14.5 13.25V2.75C14.5 2.05964 13.9404 1.5 13.25 1.5H2.75ZM4.75 7C5.16421 7 5.5 6.66421 5.5 6.25C5.5 5.83579 5.16421 5.5 4.75 5.5C4.33579 5.5 4 5.83579 4 6.25C4 6.66421 4.33579 7 4.75 7ZM7.25 5.5C6.83579 5.5 6.5 5.83579 6.5 6.25C6.5 6.66421 6.83579 7 7.25 7L11.25 7C11.6642 7 12 6.66421 12 6.25C12 5.83579 11.6642 5.5 11.25 5.5H7.25ZM4.75 10.5C5.16421 10.5 5.5 10.1642 5.5 9.75C5.5 9.33579 5.16421 9 4.75 9C4.33579 9 4 9.33579 4 9.75C4 10.1642 4.33579 10.5 4.75 10.5ZM7.25 9C6.83579 9 6.5 9.33579 6.5 9.75C6.5 10.1642 6.83579 10.5 7.25 10.5H11.25C11.6642 10.5 12 10.1642 12 9.75C12 9.33579 11.6642 9 11.25 9H7.25Z", fill: colors[0], fillRule: "evenodd", clipRule: "evenodd" }));
    },
    name: 'group_filled',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V13.25C1.5 13.9404 2.05964 14.5 2.75 14.5H13.25C13.9404 14.5 14.5 13.9404 14.5 13.25V2.75C14.5 2.05964 13.9404 1.5 13.25 1.5H2.75ZM4.75 7C5.16421 7 5.5 6.66421 5.5 6.25C5.5 5.83579 5.16421 5.5 4.75 5.5C4.33579 5.5 4 5.83579 4 6.25C4 6.66421 4.33579 7 4.75 7ZM7.25 5.5C6.83579 5.5 6.5 5.83579 6.5 6.25C6.5 6.66421 6.83579 7 7.25 7L11.25 7C11.6642 7 12 6.66421 12 6.25C12 5.83579 11.6642 5.5 11.25 5.5H7.25ZM4.75 10.5C5.16421 10.5 5.5 10.1642 5.5 9.75C5.5 9.33579 5.16421 9 4.75 9C4.33579 9 4 9.33579 4 9.75C4 10.1642 4.33579 10.5 4.75 10.5ZM7.25 9C6.83579 9 6.5 9.33579 6.5 9.75C6.5 10.1642 6.83579 10.5 7.25 10.5H11.25C11.6642 10.5 12 10.1642 12 9.75C12 9.33579 11.6642 9 11.25 9H7.25Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
